import React from 'react';
import { useLocation } from 'react-router-dom';
import StickySideRailAds, { useStickySideRailAdCount } from '../ads/StickySideRailAds';
import PageShellStickySideRail from './PageShellStickySideRail';
import { useAIHelper } from '../../contexts/AIHelperContext';

const ShellMainWithStickyAdRail = ({
  as: Component = 'main',
  children,
  className = '',
  mainClassName = '',
  showStickyAdRail = true,
  railPlacementBase = 'sticky-side-rail',
  testId = 'shell-main-with-sticky-ad-rail',
}) => {
  const location = useLocation();
  const { isOpen: isAIPanelOpen } = useAIHelper();
  const { showAds, adCount } = useStickySideRailAdCount();
  const shouldRenderRail = showStickyAdRail && !isAIPanelOpen && showAds && adCount >= 1;
  const routeRailInstanceKey =
    location?.key || `${location?.pathname || ''}?${location?.search || ''}`;

  if (!showStickyAdRail) {
    return (
      <Component className={className}>
        {children}
      </Component>
    );
  }

  return (
    <PageShellStickySideRail
      as={Component}
      className={className}
      mainClassName={mainClassName}
      rail={shouldRenderRail ? (
        <StickySideRailAds
          key={routeRailInstanceKey}
          adCount={adCount}
          placementBase={railPlacementBase}
        />
      ) : null}
      testId={testId}
    >
      {children}
    </PageShellStickySideRail>
  );
};

export default ShellMainWithStickyAdRail;
